/* Miter Rail landing page - interactive bits */
(function () {
  'use strict';

  // ------- Install stepper tabs -------
  var stepsContainer = document.querySelector('[data-mr-install-steps]');
  if (stepsContainer) {
    var stepButtons = stepsContainer.querySelectorAll('[data-mr-step]');
    var stepImages = document.querySelectorAll('[data-mr-step-img]');
    var stepProgress = document.querySelectorAll('[data-mr-step-dot]');
    var stepLabel = document.querySelector('[data-mr-step-label]');

    function activateStep(i) {
      stepButtons.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      stepImages.forEach(function (img, j) { img.classList.toggle('is-active', j === i); });
      stepProgress.forEach(function (dot, j) { dot.classList.toggle('is-on', j <= i); });
      if (stepLabel) stepLabel.textContent = 'STEP ' + String(i + 1).padStart(2, '0') + ' / ' + String(stepButtons.length).padStart(2, '0');
    }

    stepButtons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { activateStep(i); });
    });
  }

  // ------- Gallery thumbs -------
  document.querySelectorAll('[data-mr-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-mr-thumb]');
    var mainImg = gallery.querySelector('[data-mr-main-img]');
    var counter = gallery.querySelector('[data-mr-counter]');
    var total = thumbs.length;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        if (mainImg) mainImg.src = t.dataset.src;
        if (counter) counter.textContent = (i + 1) + ' / ' + total;
      });
    });
  });

  // ------- FAQ accordion -------
  document.querySelectorAll('[data-mr-faq]').forEach(function (item) {
    var btn = item.querySelector('.mr-faq-q');
    var body = item.querySelector('.mr-faq-a');
    if (!btn || !body) return;
    body.style.display = 'none';
    btn.addEventListener('click', function () {
      var on = item.hasAttribute('open');
      if (on) {
        item.removeAttribute('open');
        body.style.display = 'none';
      } else {
        item.setAttribute('open', '');
        body.style.display = 'block';
      }
    });
  });

  // ------- Sticky ATC on scroll -------
  var sticky = document.querySelector('[data-mr-sticky]');
  if (sticky) {
    var onScroll = function () {
      if (window.scrollY > 1200) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();